module.exports = __webpack_public_path__ + "img/8.dirty_floor.e50e1e85.svg";